import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** ADD SUB GROUP ACCOUNT DETAILS START *********************** */
export const SubGroupAccountDetailsAdd = (addData: any) => {
	const data = {
		CreateSubGroupAccountToken: addData,
	};
	const url = `${FIN_API_URL}createSubGroupAccount`;
	return makeApiCall(url, data);
};
/** ***************** ADD SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS START *********************** */
export const SubGroupAccountDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateSubGroupAccountToken: updateData,
	};
	const url = `${FIN_API_URL}updateSubGroupAccount`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** GET SUB GROUP ACCOUNT LIST START *********************** */
export const SubGroupAccountListGet = (listData: any) => {
	const data = {
		FetchAllSubGroupAccountToken: listData,
	};
	const url = `${FIN_API_URL}getAllSubGroupAccount`;
	return makeApiCall(url, data);
};
/** ***************** GET SUB GROUP ACCOUNT LIST END *********************** */

/** ***************** FETCH SUB GROUP ACCOUNT DETAILS START *********************** */
export const SubGroupAccountDetailsFetch = (fetchData: any) => {
	const data = {
		FetchSubGroupAccountToken: fetchData,
	};
	const url = `${FIN_API_URL}getSubGroupAccount`;
	return makeApiCall(url, data);
};
/** ***************** FETCH SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** DELETE SUB GROUP ACCOUNT DETAILS START *********************** */
export const SubGroupAccountDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteSubGroupAccountToken: deleteData,
	};
	const url = `${FIN_API_URL}deleteSubGroupAccount`;
	return makeApiCall(url, data);
};
/** ***************** DELETE SUB GROUP ACCOUNT DETAILS END *********************** */
